import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag, convertKataToRome} from "../../utils";
import {WINDOW, DOCUMENT, IS_MOBILE} from '../../constants/environment'
import './styles.css';
import Slider from "../../components/slider";
import Cta from "../cta";
import ModalWindow from "../../components/modal-window";
import BodyControl from "../../components/body";

import ImageStars from './mask_stars.png';
import IconBlank from './icon_blank.png';

/**
 *  DriversVoice
 */
class DriversVoice extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    pcTitle: PropTypes.string,
    mbTitle: PropTypes.string,
    ownerSrc: PropTypes.string,
    testDriveSrc: PropTypes.string,
    snippet: PropTypes.shape({
      description: PropTypes.string,
      totalRate: PropTypes.string,
      ratingCount: PropTypes.string
    }),
    shareButtons: PropTypes.array,
    modelName: PropTypes.string, 
    bodyTypes: PropTypes.arrayOf(PropTypes.shape({
      carTypeCode: PropTypes.string, 
      carId: PropTypes.string, 
      bodyTypeModel: PropTypes.string, 
      BodyTypeTabName: PropTypes.string, 
      totalRate: PropTypes.string,
      href: PropTypes.string,
      satisfactions: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string, 
        rate: PropTypes.string, 
      })), 
      lists: PropTypes.arrayOf(PropTypes.shape({
        kind: PropTypes.string, 
        title: PropTypes.string, 
        rate: PropTypes.string,
        name: PropTypes.string,
        age: PropTypes.string,
        sex: PropTypes.string,
        address: PropTypes.string,
        family: PropTypes.string,
        carName: PropTypes.string,
        gradeName: PropTypes.string,
        bodyColor: PropTypes.string,
        comment: PropTypes.string,
        href: PropTypes.string,
        clap: PropTypes.string
      }))
    }))
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    pcTitle: null,
    mbTitle: null,
    ownerSrc: null,
    testDriveSrc: null,
    snippet: null,
    shareButtons: null,
    modelName: null,
    bodyTypes: null
  };
  
  constructor(props) {
    super();
    this.props = props;

    this.state = {
      bodyTypeName: '',
      currentIndex: 1
    };

    this.tmp = {
      bodyTypeName: ''
    };

    this.isOpenModal = false;

    this.currentTabIndex = 0;
  }

  componentDidMount() {
    if(this.refs.form){
      const firstBodyTypeName = this.refs.form.querySelector('input[name="bodyTypeName"]');
      if(firstBodyTypeName){
        let value = firstBodyTypeName.value;
        this.tmp.bodyTypeName = value;
        this.setState({
          bodyTypeName: value
        });
      }
    }

    //モバイル用の初期表示セット
    let i = 0;
    while(true){
      let voiceListMb = this.refs['voiceListMb_' + i];
      if(!voiceListMb){
        break;
      }
      let voices = voiceListMb.querySelectorAll('.DriversVoice__modal__voiceList__voices__voice');
      if(voices && voices.length > 0){
        voices[0].classList.add('show');
      }
      i++;
    }

    //JSON+LD
    if(this.refs.jsonld){
      let json = {
        "@context": "http://schema.org",
        "@type": "Product",
        name: String(this.props.modelName),
        "description": String(this.props.snippet.description),
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": String(this.props.snippet.totalRate),
          "bestRating": "5",
          "worstRating": "1",
          "ratingCount": String(this.props.snippet.ratingCount)
        }
      };
      this.refs.jsonld.innerHTML = JSON.stringify(json);
    }

    //IE only
    if(WINDOW.navigator.userAgent && this.refs.driversvoice){
      const ua = WINDOW.navigator.userAgent.toLowerCase();
      if(ua.match(/msie/) || ua.match(/trident/)) {
        const slickPrevs = this.refs.driversvoice.querySelectorAll('.slick-prev');
        const slickNexts = this.refs.driversvoice.querySelectorAll('.slick-next');
        const itemLinks = this.refs.driversvoice.querySelectorAll('.DriversVoice__container__voiceList__item__link');
        if(slickPrevs && slickPrevs.length > 0){
          for(let i = 0; i < slickPrevs.length; i++){
            slickPrevs[i].classList.add('hover-disabled');
          }
        }
        if(slickNexts && slickNexts.length > 0){
          for(let i = 0; i < slickNexts.length; i++){
            slickNexts[i].classList.add('hover-disabled');
          }
        }
        if(itemLinks && itemLinks.length > 0){
          for(let i = 0; i < itemLinks.length; i++){
            itemLinks[i].classList.add('hover-disabled');
          }
        }
      }
    }
    
    
    //スクロールイベント
    // WINDOW.addEventListener('scroll', this.onScroll);
    // this.triggerEvent(WINDOW, 'scroll');

    // this.openModal();
  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      pcTitle,
      mbTitle,
      ownerSrc,
      testDriveSrc,
      snippet,
      shareButtons,
      modelName,
      bodyTypes
    } = this.props;

    if(bodyTypes == null){
      return (<div></div>)
    }

    let _bodyType = this.getBodyType(bodyTypes);

    let pcTitleText = pcTitle && pcTitle !== '' ? pcTitle : null;
    let mbTitleText = mbTitle && mbTitle !== '' ? mbTitle : (pcTitle && pcTitle !== '' ? pcTitle : null);

    let carImageSrc = '/globalassets/assets/cars/' + this.format(modelName) + '/' + this.format(_bodyType.carId) + '/' + this.format(_bodyType.carTypeCode) + '/common/default_s.png';
    // carImageSrc = '/assets-dev/atenza-sedan_gj7_default_s.png';

    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div className='DriversVoice' ref='driversvoice'>
          <div className='DriversVoice__container'>
            <div className='DriversVoice__container__title'>
              {pcTitleText ? <span className='DriversVoice__container__title__text--pc Wysiwyg' dangerouslySetInnerHTML={{__html: pcTitleText}} /> : null}
              {mbTitleText ? <span className='DriversVoice__container__title__text--mb Wysiwyg' dangerouslySetInnerHTML={{__html: mbTitleText}}/> : null}
            </div>
            {(() => {
              let tabNames = this.getTabNames(bodyTypes);
              if(tabNames.length > 0){
                return(
                  <form 
                    className={
                      'DriversVoice__container__form' + 
                      (tabNames.length === 1 ? ' hide' : '')
                    } 
                    ref="form" 
                    onChange={this.onChangeForm}
                  >
                    <ul className='DriversVoice__container__form__list'>
                      {
                        tabNames.map((tabName, index) => {
                          return(
                            <li className='DriversVoice__container__form__list__item' key={index}>
                              <label className="DriversVoice__container__form__list__item__label">
                                <input className="DriversVoice__container__form__list__item__label__radio" type="radio" name="bodyTypeName" value={tabName} checked={this.state.bodyTypeName === tabName} onChange={this.onChangeBodyTypeName} />
                                <span className="DriversVoice__container__form__list__item__label__text">{tabName}</span>
                              </label>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </form>
                )
              }
            })()}
            <div className='DriversVoice__container__voiceData' ref='voiceData'>
              <div className='DriversVoice__container__satisfaction'>
                <div className='DriversVoice__container__satisfaction__total'>
                  <div className='DriversVoice__container__satisfaction__total__title'>総合満足度</div>
                  <div className='DriversVoice__container__satisfaction__total__container'>
                    <div className='DriversVoice__container__satisfaction__total__container__image-container'>
                      <img src={carImageSrc} className='DriversVoice__container__satisfaction__total__container__image-container__image' />
                    </div>
                    <div className='DriversVoice__container__satisfaction__total__container__rate-container'>
                      <Stars
                        {...{
                          prefix: '',
                          suffix: 'POINT',
                          rate: parseFloat(_bodyType.totalRate),
                          animation: true
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className='DriversVoice__container__satisfaction__point'>
                  <div className='DriversVoice__container__satisfaction__point__title'>満足ポイント トップ３</div>
                    {(() => {
                      // let points = this.getSatisfactionPoints(bodyTypes);
                      let points = _bodyType.satisfactions;
                      if(points && points.length > 0){
                        return(
                          <ul className='DriversVoice__container__satisfaction__point__list'>
                            {
                              points.map((point, index) => {
                                return(
                                  <li className='DriversVoice__container__satisfaction__point__list__item' key={index}>
                                    <div>
                                      <PieChart
                                        {...{
                                          suffix: '%',
                                          rate: parseFloat(point.rate),
                                          animation: true
                                        }}
                                      />
                                    </div>
                                    <div className='DriversVoice__container__satisfaction__point__list__item__title'>{point.title}</div>
                                  </li>
                                )
                              })
                            }
                          </ul>
                        )
                      }
                    })()}
                </div>
              </div>
              <div className='DriversVoice__container__voices'>
                <div className='DriversVoice__container__voices__container'>
                  {
                    bodyTypes.map((bodyType, index) => {
                      return (
                        <React.Fragment key={index}>
                        {(() => {
                          if(bodyType.lists && Array.isArray(bodyType.lists) && bodyType.lists.length > 0){
                            return (
                              <div
                                className={
                                  'DriversVoice__container__voiceList' + 
                                  (bodyType.bodyTypeTabName === this.tmp.bodyTypeName || bodyTypes.length === 1 ? ' show' : '')
                                }
                                key={index}>
                                <Slider ref={'mainSlider_'+index} settings={{
                                  autoplay: false,
                                  autoplaySpeed: 3000,
                                  speed: 1000,
                                  ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                                  fade: false,
                                  infinite: true,
                                  slidesToShow: 1,
                                  slidesToScroll: 1,
                                  swipe: true,
                                  draggable: false,
                                  arrows: true,
                                  dots: true,
                                  adaptiveHeight: false,
                                  centerMode: false,
                                  centerPadding: 0,
                                  waitForAnimate: false,
                                  lazyLoad: 'progressive',
                                  // appendDots: (dots)=> {
                                  //   return (
                                  //     <ol>{dots}</ol>
                                  //   )
                                  // },
                                  beforeChange: (oldIndex, newIndex)=> {
                                    if(!this.isOpenModal){
                                      let currentModalSlider = this.refs['modalSlider_' + this.currentTabIndex];
                                      if(currentModalSlider){
                                        currentModalSlider.slickGoTo(newIndex);
                                      }
                                    }
                                    this.refs['mainSlider_'+index].beforeChange(oldIndex, newIndex);
                                  },
                                  responsive: [
                                    {
                                      breakpoint: 767,
                                      settings: {
                                        arrows: false,
                                      }
                                    }
                                  ]
                                  // responsive: [
                                  //   {
                                  //     breakpoint: 767,
                                  //     settings: {
                                  //       speed: 500,
                                  //       slidesToShow: 1,
                                  //       slidesToScroll: 1,
                                  //       centerMode: true,
                                  //       centerPadding: '10%',
                                  //       dots: false,
                                  //     },
                                  //   },
                                  // ],
                                }}>
                                  {(() => {
                                    if(bodyType.lists && Array.isArray(bodyType.lists) && bodyType.lists.length > 0){
                                      return(
                                        bodyType.lists.map((voice, index) => {
                                          return(
                                            <div className='DriversVoice__container__voiceList__item' key={index}>
                                              <a href='javascript:void(0)' className='DriversVoice__container__voiceList__item__link' onClick={this.openModal}>
                                                <div className='DriversVoice__container__voiceList__item__title'>{voice.title}</div>
                                                <div className='DriversVoice__container__voiceList__item__name'>{voice.name}（{voice.age}/{voice.sex === '1' ? '男性' : (voice.sex === '2' ? '女性' : '')}）</div>
                                                <div className='DriversVoice__container__voiceList__item__star'>
                                                  <Stars
                                                    {...{
                                                      rate: parseFloat(voice.rate),
                                                      animation: false,
                                                      showTitle: false
                                                    }}
                                                  />
                                                </div>
                                                <div className='DriversVoice__container__voiceList__item__comment'>コメントを見る</div>
                                              </a>
                                            </div>
                                          )
                                        })
                                      )
                                    }
                                  })()}
                                </Slider>
                              </div>
                            )
                          }
                        })()}
                        </React.Fragment>
                      )
                    })
                  }
                </div>
              </div>
              <div 
                className={
                  'DriversVoice__container__button' + 
                  (_bodyType.lists && Array.isArray(_bodyType.lists) && _bodyType.lists.length > 0 ? '' : ' no-voice')
                }
              >
                <Cta
                  {...{
                    ctaType: 'Free',
                    href: this.replaceCarName(_bodyType.href),
                    targetBlank: true,
                    text: 'ドライバーズボイス一覧',
                    linkType: 'Button',
                    color: 'Dark',
                    buttonStyle: 'Standard'
                  }}
                />
              </div>
            </div>
          </div>
          <ModalWindow ref="modalWindow" type="Light" onClose={this.closeModal}>
            <div className='DriversVoice__modal'>
            {
              bodyTypes.map((bodyType, index) => {
                return (
                  <div
                    className={
                      'DriversVoice__modal__voiceList' +
                      (bodyType.bodyTypeTabName === this.tmp.bodyTypeName || bodyTypes.length === 1 ? ' show' : '')
                    }
                    key={index}>
                    <Slider ref={'modalSlider_'+index} settings={{
                      autoplay: false,
                      autoplaySpeed: 3000,
                      speed: 1000,
                      ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                      fade: false,
                      infinite: true,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      swipe: true,
                      draggable: false,
                      arrows: true,
                      dots: true,
                      adaptiveHeight: false,
                      centerMode: false,
                      centerPadding: 0,
                      waitForAnimate: false,
                      lazyLoad: 'progressive',
                      // appendDots: (dots)=> {
                      //   return (
                      //     <ol>{dots}</ol>
                      //   )
                      // },
                      beforeChange: (oldIndex, newIndex)=> {
                        if(this.isOpenModal){
                          let currentMainSlider = this.refs['mainSlider_' + this.currentTabIndex];
                          if(currentMainSlider){
                            currentMainSlider.slickGoTo(newIndex);
                          }
                        }

                        //モバイル用の表示切り替え
                        let currentVoiceListMb = this.refs['voiceListMb_' + this.currentTabIndex];
                        if(currentVoiceListMb){
                          let voices = currentVoiceListMb.querySelectorAll('.DriversVoice__modal__voiceList__voices__voice');
                          if(voices && voices.length > 0){
                            for(let i = 0; i < voices.length; i++){
                              let voice = voices[i];
                              voice.classList.remove('show');
                              if(i === newIndex){
                                voice.classList.add('show');
                              }
                            }
                          }
                          // fadein
                          currentVoiceListMb.classList.remove('fadein');
                          currentVoiceListMb.style.opacity = 0;
                          setTimeout(
                            () => {
                              currentVoiceListMb.classList.add('fadein');
                              currentVoiceListMb.style.opacity = 1;
                            },
                          10);
                        }

                        // console.log(this.refs['modalSlider_'+index])
                        if(this.refs['modalSlider_'+index].props.children){
                          this.refs['modalSlider_'+index].beforeChange(oldIndex, newIndex);
                        }
                        
                      },
                      responsive: [
                        {
                          breakpoint: 767,
                          settings: {
                            arrows: false,
                          }
                        }
                      ]
                      // responsive: [
                      //   {
                      //     breakpoint: 767,
                      //     settings: {
                      //       speed: 500,
                      //       slidesToShow: 1,
                      //       slidesToScroll: 1,
                      //       centerMode: true,
                      //       centerPadding: '10%',
                      //       dots: false,
                      //     },
                      //   },
                      // ],
                    }}>
                      {(() => {
                        if(bodyType.lists && Array.isArray(bodyType.lists) && bodyType.lists.length > 0){
                          return(
                            bodyType.lists.map((voice, index) => {
                              let iconSrc = voice.kind === 'o' ? ownerSrc : testDriveSrc;
                              return(
                                <div className='DriversVoice__modal__voiceList__item' key={index}>
                                  <div className='DriversVoice__modal__voiceList__item__container'>
                                    <div className='DriversVoice__modal__voiceList__item__owner'>
                                      <div className='DriversVoice__modal__voiceList__item__owner__container'>
                                        <div className='DriversVoice__modal__voiceList__item__owner__kind-icon'>
                                          <img src={iconSrc} className='DriversVoice__modal__voiceList__item__owner__kind-icon__image' />
                                        </div>
                                        <div className='DriversVoice__modal__voiceList__item__owner__kind-title'>{voice.kind === 'o' ? 'オーナー' : (voice.kind === 't' ? '試乗' : '')}コメント</div>
                                        <div className='DriversVoice__modal__voiceList__item__owner__title'>{voice.title}</div>
                                        <div className='DriversVoice__modal__voiceList__item__owner__infoContainer'>
                                          <div className='DriversVoice__modal__voiceList__item__owner__star'>
                                            <Stars
                                            {...{
                                                prefix: '総合満足度',
                                                suffix: 'POINT',
                                                rate: parseFloat(voice.rate),
                                                animation: false
                                              }}
                                            />
                                          </div>
                                          <div className='DriversVoice__modal__voiceList__item__owner__name'>
                                            <span className='DriversVoice__modal__voiceList__item__owner__name__text'>{voice.name}</span>さん
                                          </div>
                                          <div className='DriversVoice__modal__voiceList__item__owner__carInfo'>
                                            {voice.carName}/
                                            {voice.gradeName}/
                                            {voice.bodyColor}
                                          </div>
                                          <div className='DriversVoice__modal__voiceList__item__owner__info'>
                                            {voice.age}/
                                            {voice.sex === '1' ? '男性' : (voice.sex === '2' ? '女性' : '')}/
                                            {voice.address}/
                                            {voice.family}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='DriversVoice__modal__voiceList__item__voice'>
                                      <div className='DriversVoice__modal__voiceList__item__voice__scroll'>
                                        <div className='DriversVoice__modal__voiceList__item__voice__comment' dangerouslySetInnerHTML={{__html: this.nl2br(voice.comment)}} />
                                        <div className='DriversVoice__modal__voiceList__item__voice__readmore'>
                                          <Cta
                                            {...{
                                              ctaType: 'Free',
                                              href: 'https://www2.mazda.co.jp' + this.replaceCarName(voice.href),
                                              targetBlank: true,
                                              text: '続きを見る',
                                              linkType: 'Button-With-Icon',
                                              iconSrc: IconBlank,
                                              hoverIconSrc: IconBlank,
                                              color: 'Dark',
                                              buttonStyle: 'Action'
                                            }}
                                          />
                                        </div>
                                        <div className='DriversVoice__modal__voiceList__item__voice__remarks'>Driver's Voiceサイトに移動します。</div>
                                      </div>
                                      <div className='DriversVoice__modal__voiceList__item__voice__footer'>
                                        <div className='DriversVoice__modal__voiceList__item__voice__footer__clap'>
                                          <span className='DriversVoice__modal__voiceList__item__voice__footer__clap__number'>{voice.clap}</span>
                                          <span className='DriversVoice__modal__voiceList__item__voice__footer__clap__unit'>人</span>の方が、このレビューに拍手しています。
                                        </div>
                                        <div className='DriversVoice__modal__voiceList__item__voice__footer__share'>
                                          {(() => {
                                            if(shareButtons && Array.isArray(shareButtons) && shareButtons.length > 0){
                                              return(
                                                <React.Fragment>
                                                  <div className='DriversVoice__modal__voiceList__item__voice__footer__share__title'>シェアする</div>
                                                  <ul className='DriversVoice__modal__voiceList__item__voice__footer__share__list'>
                                                    {
                                                      shareButtons.map((snsName, index) => {
                                                        return(
                                                          <li className='DriversVoice__modal__voiceList__item__voice__footer__share__list__item' key={index}>
                                                            <a 
                                                              href='javascript:void(0)' 
                                                              data-shareurl={this.replaceCarName(voice.href)}
                                                              className={
                                                                'DriversVoice__modal__voiceList__item__voice__footer__share__list__item__link' + 
                                                                (snsName === 'Twitter' ? ' twitter' : '') + 
                                                                (snsName === 'Facebook' ? ' facebook' : '') + 
                                                                (snsName === 'Line' ? ' line' : '') + 
                                                                (snsName === 'Google+' ? ' google' : '')
                                                              }
                                                              onClick={
                                                                (snsName === 'Twitter' ? this.onClickTwitter : null) || 
                                                                (snsName === 'Facebook' ? this.onClickFacebook : null) || 
                                                                (snsName === 'Line' ? this.onClickLine : null) || 
                                                                (snsName === 'Google+' ? this.onClickGoogle : null)
                                                              }
                                                            >
                                                              {snsName}
                                                            </a>
                                                          </li>
                                                        )
                                                      })
                                                    }
                                                  </ul>
                                                </React.Fragment>
                                              )
                                            }
                                          })()}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            })
                          )
                        }
                      })()}
                    </Slider>
                    <div className='DriversVoice__modal__voiceList__voices--mb' ref={'voiceListMb_'+index}>
                    {(() => {
                      if(bodyType.lists && Array.isArray(bodyType.lists) && bodyType.lists.length > 0){
                        return(
                          bodyType.lists.map((voice, index) => {
                            return(
                              <div className='DriversVoice__modal__voiceList__voices__voice' key={index}>
                                <div className='DriversVoice__modal__voiceList__voices__voice__comment' dangerouslySetInnerHTML={{__html: this.nl2br(voice.comment)}} />
                                <div className='DriversVoice__modal__voiceList__voices__voice__readmore'>
                                  <Cta
                                    {...{
                                      ctaType: 'Free',
                                      href: 'https://www2.mazda.co.jp' + this.replaceCarName(voice.href),
                                      targetBlank: true,
                                      text: '続きを見る',
                                      linkType: 'Button-With-Icon',
                                      iconSrc: IconBlank,
                                      hoverIconSrc: IconBlank,
                                      color: 'Dark',
                                      buttonStyle: 'Action'
                                    }}
                                  />
                                </div>
                                <div className='DriversVoice__modal__voiceList__voices__voice__remarks'>Driver's Voiceサイトに移動します。</div>
                                <div className='DriversVoice__modal__voiceList__voices__voice__footer'>
                                  <div className='DriversVoice__modal__voiceList__voices__voice__footer__clap'>
                                    <span className='DriversVoice__modal__voiceList__voices__voice__footer__clap__number'>{voice.clap}</span>
                                    <span className='DriversVoice__modal__voiceList__voices__voice__footer__clap__unit'>人</span>の方が、このレビューに拍手しています。
                                  </div>
                                  <div className='DriversVoice__modal__voiceList__voices__voice__footer__share'>
                                    {(() => {
                                      if(shareButtons && Array.isArray(shareButtons) && shareButtons.length > 0){
                                        return(
                                          <React.Fragment>
                                            <div className='DriversVoice__modal__voiceList__voices__voice__footer__share__title'>シェアする</div>
                                            <ul className='DriversVoice__modal__voiceList__voices__voice__footer__share__list'>
                                              {
                                                shareButtons.map((snsName, index) => {
                                                  return(
                                                    <li className='DriversVoice__modal__voiceList__voices__voice__footer__share__list__item' key={index}>
                                                      <a 
                                                        href='javascript:void(0)' 
                                                        data-shareurl={voice.href}
                                                        className={
                                                          'DriversVoice__modal__voiceList__voices__voice__footer__share__list__item__link' + 
                                                          (snsName === 'Twitter' ? ' twitter' : '') + 
                                                          (snsName === 'Facebook' ? ' facebook' : '') + 
                                                          (snsName === 'Line' ? ' line' : '') + 
                                                          (snsName === 'Google+' ? ' google' : '')
                                                        }
                                                        onClick={
                                                          (snsName === 'Twitter' ? this.onClickTwitter : null) || 
                                                          (snsName === 'Facebook' ? this.onClickFacebook : null) || 
                                                          (snsName === 'Line' ? this.onClickLine : null) || 
                                                          (snsName === 'Google+' ? this.onClickGoogle : null)
                                                        }
                                                      >
                                                        {snsName}
                                                      </a>
                                                    </li>
                                                  )
                                                })
                                              }
                                            </ul>
                                          </React.Fragment>
                                        )
                                      }
                                    })()}
                                  </div>
                                </div>
                              </div>
                            )
                          })
                        )
                      }
                    })()}
                    </div>
                  </div>
                )
              })
            }
            </div>
          </ModalWindow>
        </div>
        <script type="application/ld+json" ref='jsonld'>
        {(() => {
          // let json = {
          //   "@context": "http://schema.org",
          //   "@type": "Product",
          //   name: modelName,
          //   "description": snippet.description,
          //   "aggregateRating": {
          //     "@type": "AggregateRating",
          //     "ratingValue": snippet.totalRate,
          //     "bestRating": "5",
          //     "worstRating": "1",
          //     "ratingCount": snippet.ratingCount
          //   }
          // };
          // return(JSON.stringify(json))
        })()}
        </script>
      </Wrapper>
    )
  }

  getTabNames = (bodyTypes) => {
    let tabNames = [];
    if(bodyTypes && Array.isArray(bodyTypes)){
      bodyTypes.map((bodyType, index) => {
        if(bodyType.bodyTypeTabName && bodyType.bodyTypeTabName !== ''){
          tabNames.push(bodyType.bodyTypeTabName);
        }
        else{
          tabNames.push('');
        }
      });
    }
    return tabNames;
  };

  getBodyType = (bodyTypes) => {
    let currentBodyType = null;
    if(bodyTypes && Array.isArray(bodyTypes)){
      bodyTypes.map((bodyType, index) => {
        if(bodyType.bodyTypeTabName && bodyType.bodyTypeTabName === this.tmp.bodyTypeName){
          currentBodyType = bodyType;
        }
      });
    }
    if(this.tmp.bodyTypeName === ''){
      currentBodyType = bodyTypes[0];
    }
    return currentBodyType;
  };

  onChangeForm = (e) => {

  };

  onChangeBodyTypeName = (e) => {

    this.tmp.bodyTypeName = e.target.value;
    this.setState({
      bodyTypeName: e.target.value
    });

    let bodyTypes = this.props.bodyTypes;
    if(bodyTypes && Array.isArray(bodyTypes)){
      bodyTypes.map((bodyType, index) => {
        if(bodyType.bodyTypeTabName && bodyType.bodyTypeTabName === this.tmp.bodyTypeName){
          this.currentTabIndex = index;
        }
      });
    }

    //fadein
    this.refs.voiceData.classList.remove('fadein');
    this.refs.voiceData.style.opacity = 0;
    setTimeout(
      () => {
        this.refs.voiceData.classList.add('fadein');
        this.refs.voiceData.style.opacity = 1;
      },
    1);
  };

  openModal = () => {
    this.isOpenModal = true;
    this.refs.modalWindow.open('Light', 'Light');
    //BodyControl.openModal();
  };

  closeModal = () => {
    this.isOpenModal = false;
    //BodyControl.closeModal();
  };

  onScroll = (e) => {
    // console.log('scroll');
  };

  onClickTwitter = (e) => {
    // console.log('twitter');
    let url = e.target.dataset['shareurl'];
    let href = "https://twitter.com/intent/tweet?url=" + url;
    window.open(href, '_blank', 'width=600, height=600, menubar=no, toolbar=no, scrollbars=yes');
    e.preventDefault();
  };

  onClickFacebook = (e) => {
    // console.log('facebook');
    let url = e.target.dataset['shareurl'];
    let href = "https://www.facebook.com/sharer.php?src=bm&u=" + url;
    window.open(href, '_blank', 'width=600, height=600, menubar=no, toolbar=no, scrollbars=yes');
    e.preventDefault();
  };

  onClickGoogle = (e) => {
    // console.log('google');
    let url = e.target.dataset['shareurl'];
    let href = "https://plus.google.com/share?url=" + url;
    window.open(href, '_blank', 'width=600, height=600, menubar=no, toolbar=no, scrollbars=yes');
    e.preventDefault();
  };

  onClickLine = (e) => {
    // console.log('line');
    let url = e.target.dataset['shareurl'];
    let href = "https://line.me/R/msg/text/?" + url;
    window.open(href, '_blank', 'width=600, height=600, menubar=no, toolbar=no, scrollbars=yes');
    e.preventDefault();
  };

  applyFilter = () => {

  };

  format = (str) => {
    return convertKataToRome(String(str).toLowerCase().split(' ').join('-'));
  };

  triggerEvent = (element, event) => {
    if (document.createEvent) {
      // IE以外
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent(event, true, true ); // event type, bubbling, cancelable
      return element.dispatchEvent(evt);
    } else {
      // IE
      var evt = document.createEventObject();
      return element.fireEvent("on"+event, evt)
    }
  };

  replaceCarName = (str) => {
    if(!str){
      return '';
    }

    let _str = str;
    return _str.replace(/(atenza|axela)\-[a-zA-Z0-9]+/g, (match) => {
      return match.split('-').join('_');
    });

  };

  nl2br = (str) => {
    let _str = str;
    return _str.split('¥n').join('<br />').split('\n').join('<br />');
  }
  
}

export default DriversVoice;

class Stars extends Component {
  static propTypes = {
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    rate: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    animation: PropTypes.bool,
    showTitle: PropTypes.bool,
  };
  static defaultProps = {
    prefix: null,
    suffix: null,
    rate: null,
    width: 350,
    height: 54, 
    animation: false,
    showTitle: true
  };
  
  constructor(props) {
    super(props);
    this.state = {
      currentRate: 0
    };

    this.canvas = null;
    this.ctx = null;
    this.animationId = null;

    this.maskImage = null;
    this.currentRate = 0;
  }

  componentDidMount() {
    this.canvas = this.refs.canvas;
    this.ctx = this.canvas.getContext('2d');

    this.maskImage = new Image();
    this.maskImage.addEventListener("load", this.start, false);
    this.maskImage.src = ImageStars;

    // this.start();
  };

  componentWillReceiveProps(props) {
    this.currentRate = 0;
  }

  render() {
    const {
      prefix,
      suffix,
      rate,
      width,
      height,
      animation,
      showTitle
    } = this.props;

    return (
      <div className='Stars'>
        <div className='Stars__container'>
          {showTitle ? 
            <div className='Stars__container__title'>
              {prefix && prefix !== '' ? <span className='Stars__container__title__prefix'>{prefix}</span> : null}
              {rate ? <span className='Stars__container__title__rate'>{this.state.currentRate.toFixed(1)}</span> : null}
              {suffix && suffix !== '' ? <span className='Stars__container__title__suffix'>{suffix}</span> : null}
            </div>
          : null}
          <canvas width={width} height={height} className='Stars__container__canvas' ref='canvas'></canvas>
        </div>
      </div>
    )
  }

  start = () => {
    this.draw();
  };

  stop = () => {
    if(cancelAnimationFrame){
      cancelAnimationFrame(this.animationId);
    }
  };

  draw = () => {

    //アニメーションなし
    if(!this.props.animation){
      this.currentRate = this.props.rate;
    }

    this.setState({
      currentRate: Math.floor(this.currentRate * 10) / 10
    });

    const starsTotalWidth = 285; // 57 * 5

    let starsMargin = parseInt(this.currentRate) * 16;

    // let width = this.canvas.width * this.currentRate / 5;
    let width = starsTotalWidth * this.currentRate / 5;
    width += starsMargin;
    width = parseInt(width * 10) / 10;

    this.ctx.save();

    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

    this.ctx.beginPath();
    this.ctx.fillStyle = 'rgb(231, 231, 231)';
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.fill();

    this.ctx.beginPath();
    this.ctx.fillStyle = 'rgb(16, 16, 16)';
    this.ctx.fillRect(0, 0, width, this.canvas.height);
    this.ctx.fill();

    this.ctx.globalCompositeOperation = 'destination-in';
    this.ctx.drawImage(this.maskImage, 0, 0, this.canvas.width, this.canvas.height);

    this.ctx.restore();

    this.currentRate += (this.props.rate - this.currentRate) * 0.05;
    if( Math.abs(this.props.rate - this.currentRate) < 0.05 ){
      this.currentRate = this.props.rate;
    }

    if(requestAnimationFrame && this.props.animation){
      this.animationId = requestAnimationFrame(this.draw);
    }
  };
}

class PieChart extends Component {
  static propTypes = {
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    rate: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    radius: PropTypes.number,
    innerRadius: PropTypes.number,
    animation: PropTypes.bool,
  };
  static defaultProps = {
    prefix: null,
    suffix: null,
    rate: null,
    width: 194,
    height: 194,
    radius: 97,
    innerRadius: 87,
    animation: false,
  };
  
  constructor(props) {
    super(props);
    this.state = {
      currentRate: 0
    };

    this.canvas = null;
    this.ctx = null;
    this.animationId = null;

    this.maskImage = null;
    this.currentRate = 0;
  }

  componentDidMount() {
    this.canvas = this.refs.canvas;
    this.ctx = this.canvas.getContext('2d');
    this.start();
  };

  componentWillReceiveProps(props) {
    this.currentRate = 0;
  }

  render() {
    const {
      prefix,
      suffix,
      rate,
      width,
      height,
      radius,
      innerRadius,
      animation,
    } = this.props;

    return (
      <div className='PieChart'>
        <div className='PieChart__container'>
            <div className='PieChart__container__title'>
              {prefix && prefix !== '' ? <span className='PieChart__container__title__prefix'>{prefix}</span> : null}
              {rate ? <span className='PieChart__container__title__rate'>{this.state.currentRate}</span> : null}
              {suffix && suffix !== '' ? <span className='PieChart__container__title__suffix'>{suffix}</span> : null}
            </div>
          <canvas width={width} height={height} className='PieChart__container__canvas' ref='canvas'></canvas>
        </div>
      </div>
    )
  }

  start = () => {
    this.draw();
  };

  stop = () => {
    if(cancelAnimationFrame){
      cancelAnimationFrame(this.animationId);
    }
  };

  draw = () => {

    //アニメーションなし
    if(!this.props.animation){
      this.currentRate = this.props.rate;
    }

    this.setState({
      currentRate: parseInt(this.currentRate)
    });

    let angle = 360 * ( this.currentRate / 100 );

    let centerX = this.canvas.width / 2;
    let centerY = this.canvas.height / 2;
    let radius = this.props.radius;
    let innerRadius = IS_MOBILE ? this.props.innerRadius : 90;


    this.ctx.save();

    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

    this.ctx.beginPath();
    this.ctx.arc(centerX, centerY, radius, 0, Math.PI * 2, false);
    this.ctx.fillStyle = 'rgb(231, 231, 231)';
    this.ctx.fill();

    this.ctx.beginPath();
    this.ctx.arc( centerX, centerY, radius, (0 - 90) * Math.PI / 180, (angle - 90) * Math.PI / 180, false );
    this.ctx.lineTo( centerX, centerY, ) ;
    this.ctx.fillStyle = 'rgb(16, 16, 16)';
    this.ctx.fill();

    this.ctx.globalCompositeOperation = 'destination-out';
    this.ctx.beginPath();
    this.ctx.arc(centerX, centerY, innerRadius, 0, Math.PI * 2, false);
    this.ctx.fillStyle = 'rgb(231, 231, 231)';
    this.ctx.fill();

    this.ctx.restore();

    this.currentRate += (this.props.rate - this.currentRate) * 0.05;
    if( Math.abs(this.props.rate - this.currentRate) < 0.2 ){
      this.currentRate = this.props.rate;
    }

    if(requestAnimationFrame && this.props.animation){
      this.animationId = requestAnimationFrame(this.draw);
    }
  };


}




// WEBPACK FOOTER //
// ./src/containers/drivers-voice/index.jsx